<div class="basis-full flex flex-row mb-3 rounded-t-md">
  <div class="grow flex flex-row">
    <div class="text-[1.125rem] font-medium">{{headline() | translate}}</div>
  </div>
  <div>
    <!-- Custom template if provided -->
    <ng-template *ngTemplateOutlet="createButtonTemplate"></ng-template>
    
    <!-- Default button only if no custom template and createEntity is true -->
    <ng-container *ngIf="!createButtonTemplate && createEntity()">
      <nx-default-button
        [style]="'dark'"
        [icon]="'icon-plus'"
        [label]="createEntityLabel()">
      </nx-default-button>
    </ng-container>
  </div>
</div>
<div>
  <ng-container #entityContainer></ng-container>
</div>
<div
  class="text-base text-gray-400 border border-dashed border-gray-300 rounded-md min-h-[74px] flex items-center justify-center"
  *ngIf="linkedEntities().length === 0 && !loading()">
  {{emptyMessage()}}
</div>